import { render, staticRenderFns } from "./mReferences.vue?vue&type=template&id=12e2445a&scoped=true"
import script from "./mReferences.vue?vue&type=script&lang=ts"
export * from "./mReferences.vue?vue&type=script&lang=ts"
import style0 from "./mReferences.vue?vue&type=style&index=0&id=12e2445a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e2445a",
  null
  
)

export default component.exports